/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerMedias.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Media
 *  
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *  
 *  Created:    Wednesday, January 15, 2025 - 11:53 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/15/2025  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2025 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
  UPDATE_MEDIAGROUPID
} from '../constants/actionTypeMedias';

const defaultState = {
  MEDIAGROUPID: 0
};

const reducerMedias = (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_MEDIAGROUPID:
      return {
        ...state,
        MEDIAGROUPID: parseInt(action.payload) ? parseInt(action.payload) : 0,
      }
    default:
      return state;
  }
};

export default reducerMedias;
